import type { TSession } from "@/types/TSession";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useTranslation } from "react-i18next";

interface SessionCloseConfirmDialogProps {
  session: TSession | null;
  onConfirm: (sessionId: string) => void;
  onCancel: () => void;
  isOpen: boolean;
}

export function SessionCloseConfirmDialog({
  session,
  onConfirm,
  onCancel,
  isOpen,
}: SessionCloseConfirmDialogProps) {
  const { t } = useTranslation();
  
  // Use session?.session_id to ensure we only close the correct session
  const handleConfirm = () => {
    if (session?.session_id) {
      onConfirm(session.session_id);
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={(open: boolean) => !open && onCancel()}>      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("sessions.confirmClose")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("sessions.confirmCloseDescription")}
            {session && (
              <div className="mt-2">
                <p><strong>{t("sessions.id")}:</strong> {session.session_id}</p>
                <p><strong>{t("sessions.status")}:</strong> {session.status}</p>
                <p><strong>{t("sessions.mode")}:</strong> {session.mode}</p>
              </div>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="cursor-pointer">{t("sessions.cancel")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className="cursor-pointer bg-destructive text-white hover:bg-destructive/70"
          >
            {t("sessions.closeSession")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}